var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskProcessDailyTerminal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M17.078 2.5c.632 0 1.069.561 1.069 1.151V4.89h1.148c.679 0 1.106.593 1.106 1.194v1.39c0 .404-.126.82-.392 1.157L18.98 9.945v4.149h1.262c.755 0 1.258.681 1.258 1.369L21.498 21v.5H2.5v-6.037c0-.688.503-1.368 1.258-1.368h11.4v-4.15l-1.032-1.319v-.001a1.86 1.86 0 0 1-.39-1.153v-1.39c0-.6.427-1.194 1.106-1.194h1.168V3.65c0-.546.399-1.151 1.068-1.151Zm-.94 15.242h1.842v-.673h-1.842zm-5.059 0h1.842v-.673h-1.842zm-5.058 0h1.822v-.282h.02v-.39H6.02zM16.195 7.45h1.747v-.455h-1.747z"
})));
export default SvgTaskProcessDailyTerminal;